import { useContext } from "react";

import { FullPageDialogContext } from "../../contexts/FullPageDialogContext";

export const useFullPageDialogContext = () => {
  const context = useContext(FullPageDialogContext);
  if (context === undefined) {
    throw new Error(
      "useFullPageDialogContext must be within FullPageDialogContextProvider",
    );
  }

  return context;
};
